module.exports = __webpack_public_path__ + "img/add.83b3f039.svg";